import { Directive, ElementRef, AfterViewInit, OnDestroy, Input, EventEmitter, Output } from '@angular/core';
import * as $ from 'jquery';
import 'assets/vendor/jquery-maskedinput/jquery.maskedinput';
import { NgControl } from "@angular/forms";

@Directive({
    selector: '[ngModel][appMask]'
})
export class MaskDirective implements AfterViewInit, OnDestroy {
    @Input() maskPattern: string;
    @Output() ngModelChange: EventEmitter<string> = new EventEmitter<string>();
    maskObject: any;
    jqueryObject: any;
    constructor(private elementRef: ElementRef) { }

    ngOnDestroy(): void {
        this.jqueryObject.unmask();
    }
    ngAfterViewInit(): void {
        this.jqueryObject = $(this.elementRef.nativeElement);
        var options = {
            completed: (x) => {
                this.updateValue(this.jqueryObject.val());
            }
        }
        this.maskObject = this.jqueryObject.mask(this.maskPattern, options);
    }

    updateValue(newValue: string) {
        this.ngModelChange.emit(newValue);
    }
}
